import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form, Tab, Nav, Alert } from "react-bootstrap";
import { Information } from 'iconsax-react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { testoInHtml } from "../../../../components/Util/testoInHtml";
import { tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { useMemberships } from "../../../../../hooks/useMemberships";
import UserLessonsTable from "../userLessons/index";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";

import { conMotivo } from "../../../../components/Util/erroreServer";
import { numeroDaTesto, prezzoPerCampo } from "../../../../components/Util/prezzi";
import LinkAcquisto from "../../../../components/LinkAcquisto/LinkAcquisto";
import { motivoPrenotazioniFuture, useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import AvvisoFatturazione from '../../../../components/Util/AvvisoFatturazione';
import chiediConferma from '../../../../components/Util/chiediConferma';
import { NOTA_NON_IN_APP } from '../../../../components/Util/AvvisoInLista';
import { sportDelProdotto, sportDaSalvare, nomiSport } from '../../../../components/Util/sportProdotto';
export const LessonsView = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { search } = useLocation();
    const idsParam = new URLSearchParams(search).get('ids');
    const groupLessonIds = idsParam ? idsParam.split(',').filter(Boolean) : [];

    const { profile: profileData } = useProfile({ 
        autoFetch: true, 
        includeTitles: true 
    });
    const { getConfirmedMembers, memberships, loading: membershipsLoading } = useMemberships({ autoFetch: true });
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profileData?.club?.profileStatus !== 'INACTIVE';
    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const priceFieldsLocked = (fieldName) => (fieldName === 'standard_price' || fieldName === 'iva_5_percent') && sdiEnabledNoVat;

	const [loadingShowed, setLoadingShowed] = useState(false);


    const [pictureModalShowed, setPictureModalShowed] = useState(false);

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]


    const dayOptions = [
        { value: 'MONDAY', label: 'Lunedì' },
        { value: 'TUESDAY', label: 'Martedì' },
        { value: 'WEDNESDAY', label: 'Mercoledì' },
        { value: 'THURSDAY', label: 'Giovedì' },
        { value: 'FRIDAY', label: 'Venerdì' },
        { value: 'SATURDAY', label: 'Sabato' },
        { value: 'SUNDAY', label: 'Domenica' }
    ]

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });

    const [availableTeachers, setAvailableTeachers] = useState([]);
    const [groupedLessonsData, setGroupedLessonsData] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [groupSummary, setGroupSummary] = useState({
        coachIds: [],
        coachNames: [],
        statuses: new Set(),
        hasPurchasable: false,
        hasCancelled: false
    });
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    let bookingLessons = await apiClient.getBookingLessonById(token, id);
                    let groupedLessons = [];
                    if (groupLessonIds && groupLessonIds.length > 0) {
                        groupedLessons = await Promise.all(groupLessonIds.map(lid => apiClient.getBookingLessonById(token, lid)));
                        // Sostituisci i dati primari con il primo della lista per coerenza
                        bookingLessons = groupedLessons[0] || bookingLessons;
                    }
					setLoadingShowed(false);
                    
                    // Una bozza si completa nella sua pagina di modifica (come dall'elenco): qui
                    // resterebbe senza azioni.
                    const tutteBozze = groupedLessons.length > 0
                        ? groupedLessons.every(gl => gl && gl.status === 'DRAFT')
                        : bookingLessons && bookingLessons.status === 'DRAFT';
                    if (tutteBozze) {
                        navigate(`/struttura/booking/lessonseditmultiple/${id}${search || ''}`, { replace: true });
                        return;
                    }

                    if(bookingLessons) {
                        const elementFormData = {
                            id: bookingLessons.id,
                            clubId: bookingLessons.clubId,
                            name: bookingLessons.name, 
                            sportTypes: sportDelProdotto(bookingLessons),
                            type: bookingLessons.type || 'CLOSED',
                            standard_price: prezzoPerCampo(bookingLessons.standard_price),
                            member_price: prezzoPerCampo(bookingLessons.member_price),
                            federated_price: prezzoPerCampo(bookingLessons.federated_price),
                            fitcoin_cashback: bookingLessons.fitcoin_cashback,
                            payable_in_club: bookingLessons.payable_in_club,
                            payable_stripe: bookingLessons.payable_stripe,
                            payable_bank: bookingLessons.payable_bank,
                            hidden_in_app: !!bookingLessons.hidden_in_app,
                            vat_rate: bookingLessons.vat_rate,
                            vat_nature: bookingLessons.vat_nature,
                            iva_5_percent: bookingLessons.iva_5_percent,
                            status: bookingLessons.status,
                            description: bookingLessons.description,
                            lessonPicture: bookingLessons.lessonPicture,
                            coachId: (groupedLessons.length > 0) 
                                ? Array.from(new Set(groupedLessons.map(gl => String(gl.coachId)).filter(Boolean)))
                                : (bookingLessons.coachId ? String(bookingLessons.coachId) : ''),
                            venueId: bookingLessons.venueId || '',
                            startDate: bookingLessons.startDate || '',
                            endDate: bookingLessons.endDate || '',
                            weeklySchedule: bookingLessons.weeklySchedule || []
                        }
                        setFormData(elementFormData);

                        // Memorizza i dettagli del gruppo per azioni mirate
                        setGroupedLessonsData(groupedLessons && groupedLessons.length > 0 ? groupedLessons : []);

                        // Imposta il groupId se presente nella lezione o nelle lezioni del gruppo
                        const detectedGroupId = bookingLessons.groupId || (groupedLessons && groupedLessons.length > 0 ? groupedLessons[0]?.groupId : '');
                        if (detectedGroupId) {
                            setGroupId(String(detectedGroupId));
                        }

                        if (groupedLessons.length > 0) {
                            const statuses = new Set(groupedLessons.map(gl => gl.status));
                            const coachPairs = groupedLessons
                                .map(gl => ({ id: String(gl.coachId), name: gl.coachName }))
                                .filter(p => p.id);
                            const coachIds = Array.from(new Set(coachPairs.map(p => p.id)));
                            const idToName = new Map();
                            coachPairs.forEach(p => {
                                if (!idToName.has(p.id) && p.name) idToName.set(p.id, p.name);
                            });
                            const coachNamesQuick = coachIds.map(id => idToName.get(id)).filter(Boolean);
                            setGroupSummary(prev => ({
                                coachIds,
                                coachNames: coachNamesQuick,
                                statuses,
                                hasPurchasable: Array.from(statuses).includes('PURCHASABLE'),
                                hasCancelled: Array.from(statuses).includes('CANCELLED'),
                                // Archivio (TASK #7): il gruppo è archiviato se lo sono tutte le sue lezioni
                                archiviata: groupedLessons.every(gl => gl.archived)
                            }));
                        } else {
                            setGroupSummary({ 
                                coachIds: bookingLessons.coachId ? [String(bookingLessons.coachId)] : [], 
                                coachNames: bookingLessons.coachName ? [bookingLessons.coachName] : [], 
                                statuses: new Set([bookingLessons.status]), 
                                hasPurchasable: bookingLessons.status === 'PURCHASABLE', 
                                hasCancelled: bookingLessons.status === 'CANCELLED',
                                archiviata: !!bookingLessons.archived
                            });
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, [id, search]);

    const [formData, setFormData] = useState({
        id: '',
        clubId: '',
        name: '', 
        sportTypes: [],
        type: 'CLOSED',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        hidden_in_app: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        status: '',
        lessonPicture: '',
        coachId: '',
        venueId: ''
    });

    // Fetch teachers and facilities
    useEffect(() => {
        const fetchTeachersAndFacilities = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    
                    // Recupera i coach confermati (se disponibili)
                    const confirmedCoaches = Array.isArray(memberships) ? (getConfirmedMembers('COACH') || []) : [];

                    // Mappa in opzioni di Select
                    const formattedTeachers = confirmedCoaches.map(teacher => ({
                        value: String(teacher.userId),
                        label: teacher.name,
                        sportType: teacher.sportType
                    }));

                    // Determina gli ID coach rilevanti da mostrare
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    let mergedTeachers = [...formattedTeachers];

                    const selectedIds = Array.isArray(formData.coachId)
                        ? (formData.coachId || [])
                        : (formData.coachId ? [formData.coachId] : []);
                    const groupIds = groupSummary && groupSummary.coachIds ? groupSummary.coachIds : [];
                    const relevantIds = Array.from(new Set([...selectedIds.map(String), ...groupIds.map(String)]));
                    const missingCoachIds = relevantIds.filter(cid => !formattedTeachers.some(t => t.value === cid));

                    if (missingCoachIds.length > 0 && token) {
                        const apiClient = new MyApiClient();
                        const fetchedProfiles = await Promise.all(missingCoachIds.map(async (cid) => {
                            try {
                                const profile = await apiClient.getPrivateProfile(token, cid);
                                return { cid, profile };
                            } catch (e) {
                                return { cid, profile: null };
                            }
                        }));

                        const extraTeachers = fetchedProfiles.map(({ cid, profile }) => {
                            let label = `ID ${cid}`;
                            if (profile) {
                                const nameFlat = profile.name || profile.displayName || profile.username;
                                const namePair = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
                                const guruPair = profile.idsGuru ? [profile.idsGuru.givenName, profile.idsGuru.familyName].filter(Boolean).join(' ') : '';
                                const playPair = profile.idsPlay ? [profile.idsPlay.givenName, profile.idsPlay.familyName].filter(Boolean).join(' ') : '';
                                label = nameFlat || namePair || guruPair || playPair || label;
                            }
                            return { value: String(cid), label };
                        });

                        const seen = new Set();
                        mergedTeachers = [...formattedTeachers, ...extraTeachers].filter(opt => {
                            if (seen.has(opt.value)) return false;
                            seen.add(opt.value);
                            return true;
                        });
                    }

                    setGroupSummary(prev => ({
                        ...prev,
                        coachNames: (prev.coachIds || []).map(cid => mergedTeachers.find(t => t.value === String(cid))?.label).filter(Boolean)
                    }));

                    setAvailableTeachers(mergedTeachers);
                }
            } catch (error) {
                console.error("Error fetching teachers and facilities:", error);
            }
        };

        fetchTeachersAndFacilities();
    }, [memberships, membershipsLoading, getConfirmedMembers, groupSummary, formData.coachId]);

    // Costruisci opzioni da mostrare comprensive di fallback per coach selezionati non presenti nelle options
    const selectedCoachIds = Array.isArray(formData.coachId)
        ? (formData.coachId || [])
        : (formData.coachId ? [formData.coachId] : []);

    const fallbackTeacherOptions = selectedCoachIds
        .map(cid => String(cid))
        .filter(cid => !availableTeachers.some(t => t.value === cid))
        .map(cid => ({
            value: cid,
            label: (groupSummary.coachIds && groupSummary.coachNames && groupSummary.coachIds.map(String).indexOf(cid) !== -1)
                ? groupSummary.coachNames[groupSummary.coachIds.map(String).indexOf(cid)]
                : 'Decodifica in corso…'
        }));

    const displayTeachers = (() => {
        const byId = new Map();
        const source = [...availableTeachers, ...fallbackTeacherOptions];
        for (const opt of source) {
            const existing = byId.get(opt.value);
            if (!existing) {
                byId.set(opt.value, opt);
            } else {
                const isPlaceholder = !existing.label || existing.label === 'Decodifica in corso…' || existing.label.startsWith('ID ');
                if (isPlaceholder && opt.label && opt.label !== existing.label) {
                    byId.set(opt.value, opt);
                }
            }
        }
        return Array.from(byId.values());
    })();



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || false;
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const orariDaInviare = (orari) => (orari || []).map(o => ({ dayOfWeek: o.dayOfWeek, startTime: o.startTime, endTime: o.endTime }));

    const handleSaveAll = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return;
            const tokenDetails = JSON.parse(tokenDetailsString);
            const token = tokenDetails.idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const baseUpdate = {
                id: formData.id,
                clubId: formData.clubId,
                ...sportDaSalvare(formData.sportTypes),
                name: formData.name,
                description: formData.description,
                type: formData.type || 'CLOSED',
                status: formData.status,
                payable_in_club: formData.payable_in_club,
                payable_bank: formData.payable_bank,
                payable_stripe: formData.payable_stripe,
                hidden_in_app: formData.hidden_in_app,
                vat_rate: formData.vat_rate,
                vat_nature: formData.vat_nature || undefined,
                iva_5_percent: formData.iva_5_percent,
                standard_price: numeroDaTesto(formData.standard_price) || 0,
                federated_price: numeroDaTesto(formData.federated_price) || 0,
                fitcoin_cashback: parseInt(formData.fitcoin_cashback, 10) || 0,
                lessonPicture: formData.lessonPicture,
            };
            if (formData.newLessonPicture) {
                baseUpdate.newLessonPicture = {
                    content: formData.newLessonPicture,
                    name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
                };
            }

            let errors = 0;
            if (groupedLessonsData && groupedLessonsData.length > 0) {
                for (const gl of groupedLessonsData) {
                    const payload = {
                        ...baseUpdate,
                        id: gl.id,
                        coachId: String(gl.coachId || ''),
                        // Il server lo richiede per le lezioni attive (anche se non lo cambia).
                        weeklySchedule: orariDaInviare(gl.weeklySchedule),
                    };
                    Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                    const res = await apiClient.updateBookingLesson(token, payload);
                    if (!res || res.error) errors++;
                }
            } else {
                const payload = {
                    ...baseUpdate,
                    coachId: Array.isArray(formData.coachId) ? (formData.coachId[0] || '') : formData.coachId,
                    weeklySchedule: orariDaInviare(formData.weeklySchedule),
                };
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const res = await apiClient.updateBookingLesson(token, payload);
                if (!res || res.error) errors++;
            }
            setLoadingShowed(false);

            if (errors > 0) {
                setModalTitle("Errore durante l'aggiornamento");
                setModalText(conMotivo("Si è verificato un errore durante l'aggiornamento di una o più lezioni del gruppo."));
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/lessons');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error updating lesson:', error);
            setModalTitle("Errore durante l'aggiornamento");
            setModalText(conMotivo("Si è verificato un errore durante l'aggiornamento della lezione."));
            setModalShowed(true);
        }
    };

    const renderEditableField = (fieldName, label, type = 'text', options = null, isBoolean = false) => {
        const value = formData[fieldName];
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked(fieldName);
        const disabledTitle = priceFieldsLocked(fieldName)
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        const disabledStyle = { color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal' };

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">{label}</Form.Label>
                {options ? (
                    <Select
                        isDisabled={disabled}
                        isMulti={Array.isArray(value)}
                        name={fieldName}
                        value={Array.isArray(value)
                            ? options.filter(option => value.includes(option.value))
                            : options.find(option => option.value === value)}
                        onChange={(selectedOption) =>
                            isBoolean
                                ? handleSelectChangeBoolean(selectedOption, fieldName)
                                : handleSelectChange(selectedOption, fieldName)
                        }
                        options={options}
                    />
                ) : type === 'html' ? (
                    // Descrizione: lo stesso editor visuale della nuova lezione.
                    <div className="mt-2 sid-editor">
                        <CKEditor
                            editor={ClassicEditor}
                            disabled={disabled}
                            data={testoInHtml(value)}
                            onChange={(evento, editor) => {
                                const html = editor.getData();
                                setFormData(prev => ({ ...prev, [fieldName]: html }));
                            }}
                        />
                    </div>
                ) : type === 'textarea' ? (
                    <Form.Control
                        disabled={disabled}
                        as="textarea"
                        rows={10}
                        className="mt-2"
                        style={disabled ? disabledStyle : undefined}
                        name={fieldName}
                        value={value || ''}
                        onChange={handleChange}
                    />
                ) : (
                    <Form.Control
                        disabled={disabled}
                        className="mt-2"
                        style={disabled ? { ...disabledStyle, fontSize: '14px' } : undefined}
                        type={type === 'prezzo' ? 'text' : type}
                        inputMode={type === 'prezzo' ? 'decimal' : undefined}
                        name={fieldName}
                        value={(value || value === 0) ? value : ''}
                        onChange={handleChange}
                    />
                )}
            </div>
        );
    };

    // L'IVA non passa dal renderer generico: le opzioni a 0% differiscono per
    // codice Natura, quindi la voce selezionata non si trova confrontando un
    // singolo valore. Stessa logica di abilitazione degli altri campi prezzo.
    const renderVatField = () => {
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked('iva_5_percent');
        const disabledTitle = priceFieldsLocked('iva_5_percent')
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">IVA</Form.Label>
                <Select
                    className="mt-2"
                    styles={sidSelectStyles}
                    isDisabled={disabled}
                    name="vat_rate"
                    value={findVatOption(formData)}
                    onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                    options={VAT_OPTIONS}
                />
            </div>
        );
    };

    const handleDelete = async () => {
        if (await chiediConferma({
            titolo: `Eliminare la lezione${formData.name ? ` «${formData.name}»` : ''}?`,
            testo: 'La tipologia lezione sarà eliminata dalla tua struttura.',
            conferma: 'Elimina',
        })) deleteData();
    };

    const deleteData = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                let errors = 0;
                const idsToDelete = (groupedLessonsData && groupedLessonsData.length > 0)
                    ? groupedLessonsData.filter(gl => gl.status === 'PURCHASABLE' || gl.status === 'CANCELLED').map(gl => gl.id)
                    : [id];
                for (const lid of idsToDelete) {
                    const res = await apiClient.deleteBookingLesson(token, lid);
                    if (!res || res.error) errors++;
                }
                setLoadingShowed(false);

                if(errors > 0) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(conMotivo("Si è verificato un errore durante l'eliminazione di una o più lezioni del gruppo"));
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/lessons');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    };

    usePageTitle(formData?.name || null); // titolo = solo il nome del prodotto

    // Stato dalla chip accanto al titolo: vale per tutte le lezioni del gruppo (una per maestro),
    // si registra subito e si resta nella scheda
    // `archivia` (TASK #7): la voce «Archiviato» della tendina
    const cambiaStato = async (attiva, archivia = false) => {
        if (attiva && billingNotConfirmed) {
            setModalTitle("Documenti fiscali non ancora validati");
            setModalText("Non è possibile attivare la vendita di questo prodotto finché i documenti fiscali della tua struttura non sono stati validati. Per pubblicare prodotti e renderli acquistabili nell'App SportId Player devi prima configurare e confermare il metodo di fatturazione nella sezione La mia struttura → Documenti fiscali. Nel frattempo puoi continuare a creare prodotti e salvarli come bozza.");
            setModalShowed(true);
            return { annullato: true };
        }
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        if (!attiva) {
            // Non si disattiva se ci sono lezioni prenotate da oggi in poi (per uno qualsiasi dei maestri del gruppo)
            const ids = (groupedLessonsData && groupedLessonsData.length > 0) ? groupedLessonsData.map(gl => gl.id) : [id];
            const elenchi = await Promise.all(ids.map(lid => apiClient.getUserBookingLessons(token, lid)));
            const errore = elenchi.find(e => e?.error);
            if (errore) return { error: errore.error };
            const motivo = motivoPrenotazioniFuture(elenchi.flatMap(e => (Array.isArray(e) ? e : e?.items || [])), 'la lezione');
            if (motivo) return { error: motivo.replace('disattivarlo', 'disattivarla') };
        }
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const da = attiva ? 'CANCELLED' : 'PURCHASABLE';
        const motivi = [];
        const uniqueGroupIds = Array.from(new Set((groupedLessonsData || []).map(gl => gl.groupId).filter(Boolean)));
        const targetGroupIds = uniqueGroupIds.length > 0 ? uniqueGroupIds : (groupId ? [groupId] : []);
        if (targetGroupIds.length > 0) {
            for (const gid of targetGroupIds) {
                const res = await apiClient.changeLessonStatus(token, null, nuovo, gid, archivia);
                if (!res || res.error) motivi.push(res?.error);
            }
        } else {
            const ids = (groupedLessonsData && groupedLessonsData.length > 0)
                // Entrando o uscendo dall'archivio contano tutte le lezioni del gruppo tranne le bozze
                ? groupedLessonsData
                    .filter(gl => ((archivia || groupSummary.archiviata) ? gl.status !== 'DRAFT' : gl.status === da))
                    .map(gl => gl.id)
                : [id];
            for (const lid of ids) {
                const res = await apiClient.changeLessonStatus(token, lid, nuovo, undefined, archivia);
                if (!res || res.error) motivi.push(res?.error);
            }
        }
        if (motivi.length > 0) {
            return { error: motivi.find(Boolean) || 'Non è stato possibile cambiare lo stato di una o più lezioni del gruppo.' };
        }
        setFormData(prev => ({ ...prev, status: nuovo }));
        setGroupedLessonsData(prev => (prev || []).map(gl => (gl.status === 'DRAFT' ? gl : { ...gl, status: nuovo })));
        setGroupSummary(prev => ({ ...prev, hasPurchasable: attiva, hasCancelled: !attiva, archiviata: archivia }));
        return {};
    };
    const attivaLezione = groupLessonIds.length > 0 ? groupSummary.hasPurchasable : formData?.status === 'PURCHASABLE';
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: attivaLezione,
        bozza: formData?.status === 'DRAFT',
        archiviato: !!groupSummary.archiviata,
        onCambia: cambiaStato,
    });

    // Functions for planning tab


    // Formatting functions for planning tab
    const getDayOfWeek = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
        return days[date.getDay()];
    };

    const formatDateTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };



    // Nuova UI della scheda (come la nuova lezione): campi, interruttori e dati in sola lettura.
    const modificabile = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
    const puoSalvare = groupLessonIds.length > 0 ? (groupSummary.hasPurchasable || groupSummary.hasCancelled) : modificabile;
    const puoEliminare = groupLessonIds.length > 0 ? (groupSummary.hasPurchasable || groupSummary.hasCancelled) : formData.status !== 'DRAFT';
    const campo = (fieldName, label, type = 'text') => {
        const bloccato = !modificabile || priceFieldsLocked(fieldName);
        const valore = formData[fieldName];
        return (
            <div title={priceFieldsLocked(fieldName) ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata' : undefined}>
                <Form.Label className="mb-2">{label}</Form.Label>
                <Form.Control
                    disabled={bloccato}
                    className={`mt-2${bloccato ? ' sid-ro-input' : ''}`}
                    type={type === 'prezzo' ? 'text' : type}
                    inputMode={type === 'prezzo' ? 'decimal' : undefined}
                    min={type === 'number' ? '0' : undefined}
                    name={fieldName}
                    value={(valore || valore === 0) ? valore : ''}
                    onChange={handleChange}
                />
            </div>
        );
    };
    const interruttore = (fieldName, label) => (
        <div className="sid-switch-row">
            <Form.Check
                type="switch"
                id={`switch-${fieldName}`}
                label={label}
                disabled={!modificabile}
                checked={!!formData[fieldName]}
                onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
            />
        </div>
    );
    const foto = formData.newLessonPicture
        ? `data:image/jpeg;base64,${formData.newLessonPicture}`
        : (formData.lessonPicture || null);
    const nomeSport = nomiSport(formData);
    const nomiStaff = (() => {
        const scelti = Array.isArray(formData.coachId)
            ? displayTeachers.filter(option => (formData.coachId || []).map(String).includes(String(option.value)))
            : displayTeachers.filter(option => String(option.value) === String(formData.coachId));
        const nomi = scelti.map(option => option.label).filter(Boolean);
        return Array.from(new Set(nomi.length ? nomi : (groupSummary.coachNames || []).filter(Boolean)));
    })();

    // Lezioni del gruppo (una per maestro); una lezione sola se non fa parte di un gruppo.
    const lezioniDelGruppo = groupedLessonsData && groupedLessonsData.length > 0
        ? groupedLessonsData.map(gl => ({ id: String(gl.id), coachName: gl.coachName, status: gl.status }))
        : (id ? [{ id: String(id), coachName: (groupSummary.coachNames || [])[0], status: formData.status }] : []);

	return (
		<>
			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <ProductImageUploader
                show={pictureModalShowed}
                onClose={() => setPictureModalShowed(false)}
                onSave={(base64String) => {
                    setPictureModalShowed(false);
                    setFormData(prev => ({ ...prev, newLessonPicture: base64String }));
                }}
                titolo="Immagine della lezione"
            />

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            {billingNotConfirmed && (
                <AvvisoFatturazione />
            )}

            <Row className="align-items-start mt-0">
                <div className="col-xl-12">
                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey="informazioni">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="informazioni">
                                        Informazioni generali
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="acquisti">
                                        Acquisti
                                    </Nav.Link>
                                </Nav.Item>

                            </Nav>
                            {/* Un solo link per la lezione: con piu' maestri vale per tutti e nel web player chi compra
                                sceglie il maestro e il giorno, poi gli orari (15/10/2026) */}
                            {(() => {
                                const inVendita = lezioniDelGruppo.filter(l => l.status !== 'DRAFT');
                                if (inVendita.length === 0) return null;
                                const piuMaestri = inVendita.length > 1;
                                const unica = inVendita[0];
                                return (
                                    <div className="d-flex flex-wrap gap-3">
                                        <LinkAcquisto productType="lesson" productId={unica.id}
                                            perTuttiIMaestri={piuMaestri}
                                            nomeProdotto={piuMaestri
                                                ? `${formData.name} (${inVendita.length} maestri)`
                                                : (unica.coachName ? `${formData.name} con ${unica.coachName}` : formData.name)}
                                            attivo={inVendita.some(l => l.status === 'PURCHASABLE')} />
                                    </div>
                                );
                            })()}
                            </div>
                            <Row className="align-items-start mt-4">
                                <div className="col-12">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="informazioni">
                                            <Card className="sid-scheda-prodotto">
                                                <Card.Body className="sid-card-body--spaced">
                                                    <Row className="g-4">
                                                        <Col md={6}>{campo('name', 'Nome lezione')}</Col>
                                                        {/* Sport e staff tecnico come nella nuova lezione, in sola lettura:
                                                            dopo l'attivazione non si cambiano (una lezione per maestro). */}
                                                        <Col md={12}>
                                                            <div className="sid-scelta-staff">
                                                                <div className="sid-scelta-staff__passo">
                                                                    <div className="sid-scelta-staff__titolo"><span className="sid-scelta-staff__num">1</span>Sport</div>
                                                                    <div className="sid-readonly-value sid-scelta-staff__sport">{nomeSport || '—'}</div>
                                                                </div>
                                                                <div className="sid-scelta-staff__passo">
                                                                    <div className="sid-scelta-staff__titolo">
                                                                        <span className="sid-scelta-staff__num">2</span>Staff tecnico
                                                                        {nomiStaff.length > 0 && <span className="sid-scelta-staff__conta">{nomiStaff.length === 1 ? '1 maestro' : `${nomiStaff.length} maestri`}</span>}
                                                                    </div>
                                                                    {nomiStaff.length === 0 ? (
                                                                        <div className="sid-scelta-staff__vuoto">Nessun maestro indicato.</div>
                                                                    ) : (
                                                                        <div className="sid-scelta-staff__maestri">
                                                                            {nomiStaff.map(nome => (
                                                                                <span key={nome} className="sid-scelta-staff__maestro is-scelto is-fisso">{nome}</span>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                    <div className="sid-scelta-staff__aiuto">Maestri e programmazione restano quelli scelti all&apos;attivazione: c&apos;è una lezione per ogni maestro.</div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col md={12}>{renderEditableField('description', 'Descrizione', 'html')}</Col>
                                                        <Col md={12}>
                                                            <Form.Label>Foto</Form.Label>
                                                            <div className="sid-photo-field">
                                                                <div className="sid-photo-field__preview">
                                                                    {foto ? <img src={foto} alt="" /> : <span>Nessuna foto</span>}
                                                                </div>
                                                                {modificabile && (
                                                                    <Button size="sm" variant="outline-dark" onClick={() => { setNewPictureFile(null); setPictureModalShowed(true); }}>
                                                                        {foto ? 'Sostituisci foto' : 'Carica foto'}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Prezzi</h5>
                                                    <Row className="g-4">
                                                        <Col md={3}>{campo('standard_price', 'Prezzo standard', 'prezzo')}</Col>
                                                        <Col md={3}>{renderVatField()}</Col>
                                                        {showingTesseratiOptions && <Col md={3}>{campo('federated_price', 'Prezzo tesserati / soci', 'prezzo')}</Col>}
                                                        <Col md={3}>{campo('fitcoin_cashback', 'Cashback Fitcoin', 'number')}</Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Forme di pagamento</h5>
                                                    <div className="sid-switch-inline">
                                                        {interruttore('payable_in_club', 'Acquisto pagabile in struttura')}
                                                        {paymentMethods.stripe_enabled && interruttore('payable_stripe', 'Acquisto pagabile su Stripe')}
                                                        {paymentMethods.bank_transfer_enabled && interruttore('payable_bank', 'Acquisto pagabile con bonifico')}
                                                    </div>

                                                    {/* «Non pubblicare in app» (TASK #9): la lezione non compare negli orari proposti dall'app */}
                                                    <h5 className="sid-form-section">Visibilità</h5>
                                                    <div className="sid-switch-inline">
                                                        {interruttore("hidden_in_app", "Non pubblicare in app")}
                                                    </div>
                                                    {formData.hidden_in_app && <Form.Text className="d-block mt-2">{NOTA_NON_IN_APP}</Form.Text>}

                                                    <h5 className="sid-form-section">Programmazione settimanale</h5>
                                                    {formData.weeklySchedule && formData.weeklySchedule.length > 0 ? (
                                                        formData.weeklySchedule.map((item, index) => (
                                                            <Row key={index} className="g-4 mb-3">
                                                                <Col md={4}>
                                                                    <Form.Label className="mb-2">Giorno</Form.Label>
                                                                    <div className="sid-readonly-value">{dayOptions.find(option => option.value === item.dayOfWeek)?.label || item.dayOfWeek || '—'}</div>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <Form.Label className="mb-2">Ora inizio</Form.Label>
                                                                    <div className="sid-readonly-value">{item.startTime || '—'}</div>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <Form.Label className="mb-2">Ora fine</Form.Label>
                                                                    <div className="sid-readonly-value">{item.endTime || '—'}</div>
                                                                </Col>
                                                            </Row>
                                                        ))
                                                    ) : (
                                                        <div className="sid-scelta-staff__vuoto">Nessuna programmazione settimanale.</div>
                                                    )}
                                                </Card.Body>
                                            </Card>

                                            <div className={`d-flex ${puoEliminare ? 'justify-content-between' : 'justify-content-end'} align-items-center gap-4 mt-4`}>
                                                {puoEliminare && (
                                                    <button type="button" onClick={() => handleDelete()} className="btn btn-danger light">Elimina</button>
                                                )}
                                                <div className="d-flex gap-4">
                                                    {puoSalvare && <Button onClick={handleSaveAll} className="btn btn-primary">Salva</Button>}
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    <Tab.Pane eventKey="acquisti">
                                        <UserLessonsTable
                                            lessonId={id}
                                            cardTitle={'Acquisti della lezione'}
                                            headerButtons={formData.status === 'PURCHASABLE' && (
                                                <Link to={`/struttura/booking/userLessons`} className="btn btn-primary btn-sm btn-add">
                                                    <i className="fas fa-plus me-2"></i>
                                                    Nuova Vendita
                                                </Link>
                                            )}
                                        />
                                    </Tab.Pane>

                                </Tab.Content>
                                 
                             </div>
                         </Row>
                         </Tab.Container>
                     </div>
                 </div>
             </Row>
		</>
	)

}
export default LessonsView;